/**
 * Suggested plan display names for Engage / Engage+ with optional Email and Cart Abandonment add-ons.
 * Tier is Engage+ when In-Property Messaging is selected; otherwise Engage.
 */
export function getSuggestedEngageStylePlanName(serviceIds) {
  const set =
    serviceIds instanceof Set ? serviceIds : new Set(serviceIds == null ? [] : [...serviceIds])
  const hasInProperty = set.has('inproperty')
  const hasEmail = set.has('email_drip')
  const hasCart = set.has('cart_abandonment')
  const tier = hasInProperty ? 'Engage+' : 'Engage'
  if (!hasEmail && !hasCart) {
    return tier
  }
  const parts = []
  if (hasEmail) parts.push('Email')
  if (hasCart) parts.push('Cart Abandonment')
  const tail = parts.length === 2 ? `${parts[0]} and ${parts[1]}` : parts[0]
  return `${tier} with ${tail}`
}
